import { hideUserMessage, showUserMessage, UserMessageBoxState } from "@components/UserMessageBox";
import { FeatureFlags } from "@lib/features";

export enum ConnectionAlertMessage {
	CONNECTION_LOST = 'Verbindung zum Server verloren.',
	RECONNECTED = 'Verbindung wiederhergestellt.',
}

const RECONNECTED_MESSAGE_DURATION_MS = 5_000;
const RELOAD_SUGGESTION_ATTEMPT_THRESHOLD = 5;

/** Temporary debug aid, gated behind FeatureFlags.wsConnectionAlerts so it never ships permanently enabled. */
function showConnectionMessage(state: UserMessageBoxState, message: string, loading: boolean): void {
	if (FeatureFlags.wsConnectionAlerts) {
		showUserMessage({ state, message, loading });
	}
}

export function getReconnectingMessage(attempt: number): string {
	const baseMessage = `Versuche erneut zu verbinden (Versuch ${attempt})`;
	if (attempt >= RELOAD_SUGGESTION_ATTEMPT_THRESHOLD) {
		return `${baseMessage}. Versuche die Seite neu zu laden.`;
	}
	return baseMessage;
}

export function notifyConnectionLost(): void {
	showConnectionMessage(UserMessageBoxState.ERROR, ConnectionAlertMessage.CONNECTION_LOST, false);
}

export function notifyReconnecting(attempt: number): void {
	showConnectionMessage(UserMessageBoxState.WARNING, getReconnectingMessage(attempt), true);
}

export function notifyReconnected(): void {
	showConnectionMessage(UserMessageBoxState.SUCCESS, ConnectionAlertMessage.RECONNECTED, false);
	if (FeatureFlags.wsConnectionAlerts) {
		setTimeout((): void => hideUserMessage(), RECONNECTED_MESSAGE_DURATION_MS);
	}
}
